
<div class="flats-selector">
  <button @click="toggleButton(flat)" class="flat-btn" v-for="(flat,index) in flats" :class="isSelected(flat) ? 'selected' : '' ">{{flat.title}}</button>
</div>
